import { trpc } from '@/shared/api/trpc';

const useInvalidateOrg = () => {
  const utils = trpc.useUtils();
  return (id: string) => {
    utils.organizations.findOne.invalidate({ id });
    utils.auth.me.invalidate();
  };
};

/**
 * Generate a new Product API key. The raw key is in the mutation result and
 * must be shown to the operator immediately — it is never retrievable again.
 */
export const useGenerateProductApiKey = () => {
  const invalidate = useInvalidateOrg();
  return trpc.organizations.generateProductApiKey.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) invalidate(vars.id);
    },
  });
};

export const useRevokeProductApiKey = () => {
  const invalidate = useInvalidateOrg();
  return trpc.organizations.revokeProductApiKey.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) invalidate(vars.id);
    },
  });
};

/**
 * Replace the Product API IP allow-list. An empty array clears the
 * restriction (allow all).
 */
export const useSetProductApiAllowedIps = () => {
  const invalidate = useInvalidateOrg();
  return trpc.organizations.setProductApiAllowedIps.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) invalidate(vars.id);
    },
  });
};
